// extracted by mini-css-extract-plugin
export default {"toolbar":"CajasPanel_toolbar__SxNaT","field":"CajasPanel_field__zy0Ad","label":"CajasPanel_label__c296a","select":"CajasPanel_select__kqanq","tabs":"CajasPanel_tabs__G5Swm"};